<template>
    <div>
        {{ formatMoney(amount, currancy + " ", length) }}
    </div>
</template>

<script>
import { formatMoney } from 'accounting';
export default {
    name: 'PAmount',
    props: {
        amount: String,
        currancy: {
            type: String,
            default: "SDG"
        },
        length: {
            type: Number,
            default: 2
        }
    },
    methods: {
        formatMoney
    }
}
</script>

<style>

</style>